// extracted by mini-css-extract-plugin
module.exports = {"ingress":"Ingress-module__ingress___3-S8-","ingress-empty":"Ingress-module__ingress-empty___21Oap"};